import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  FIELDS,
  FormInputLevels,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import { useSelector } from "react-redux";
import { ProductValueType } from "../../../Types/Product/ProductValueType";
import { ProductError } from "../../../Types/Product/ProductError";
import { packSizeToDisplay } from "./FormHelper/productValueTypeFields";

const HierarchyForm: FC<ProductFormProps> = (props) => {
  const values = props.values as ProductValueType;
  const errors: ProductError | null | undefined = props.errors && props.errors as ProductError;

  const [isFormDirty, setIsFormDirty] = useState<boolean | undefined>(
    props.dirty || true
  );
  const pageDirtyPayload = useSelector((state: any) => state.pageDirtyReducer);

  useEffect(() => {
    if (pageDirtyPayload.data !== null) {
      let compareResult =
        JSON.stringify(pageDirtyPayload.data.values) ===
        JSON.stringify(values);
      setIsFormDirty(compareResult);
    }
  }, [pageDirtyPayload]);

  return (
    <Container>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.sainId.name}
              label={FormInputLevels.SainId}
              maxLength={128}
              value={values.sainId}
              error={errors?.sainId}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name="displayItemNumber"
              label={FormInputLevels.DisplayItemNumber}
              value={
                values.skuNumber
                  ? values.skuNumber
                  : values.catNumber
              }
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <h4 style={{ fontSize: "1.125rem" }}>Family Group</h4>
            <FamilyGroupAutoComplete
              productType={values.productType}
              className="family-Group-AutoCompleteModal"
              name="FamilyGroupNew"
              placeholder="Please select"
              testid="autocomplete-field"
              initialValue={values.familyGroup || ""}
              onSelect={(e: any) => {
                if (e === null || e?.value === null) {
                  e = {
                    label: values.familyGroup,
                    value: { desc: values.familyGroup },
                  };
                }
                props.onChange(e, e.label, e.value?.desc, false);
              }}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.description.name}
              label={FormInputLevels.Description}
              maxLength={128}
              value={values.description}
              disabled={true}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.packSize.name}
              label={FormInputLevels.PackSize}
              value={packSizeToDisplay(values)}
              disabled
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.productType.name}
              label={FormInputLevels.ProductType}
              value={values.productType}
              disabled={true}
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.businessUnit}
              label={FormInputLevels.BusinessUnit}
              maxLength={128}
              value={values.businessUnit}
              error={errors?.businessUnit}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.superCategory}
              label={FormInputLevels.SuperCategory}
              maxLength={128}
              value={values.superCategory}
              error={errors?.superCategory}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.category}
              label={FormInputLevels.Category}
              maxLength={128}
              value={values.category}
              error={errors?.category}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.subCategory.name}
              label={FormInputLevels.SubCategory}
              maxLength={128}
              value={values.subCategory}
              error={errors?.subCategory}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
          <GridItem size={{ sm: "1/4", xs: "1" }}>
            <TextInputField
              name={FIELDS.segment.name}
              label={FormInputLevels.Segment}
              maxLength={128}
              value={values.segment}
              error={errors?.segment}
              onBlur={props.onBlur}
              onChange={props.onChange}
              required
              disabled
            />
          </GridItem>
        </GridWrapper>
      </Form>
      <ActionButton
        onSubmit={props.onSubmit}
        onClearAll={props.onClearAll}
        onCancel={props.onCancel}
        isAddDisabled={isFormDirty}
        isDirty={props.dirty}
        isEdit={props.isEdit}
        isClearButtonRequired={false}
        submitted={props.submitted}
      />
    </Container>
  );
};

export default HierarchyForm;
